var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
import * as React from "react";
const SvgArrowDown = (props) => /* @__PURE__ */ React.createElement("svg", __spreadValues({ width: 12, height: 8, xmlns: "http://www.w3.org/2000/svg" }, props), /* @__PURE__ */ React.createElement("path", { d: "M11.81.138a.553.553 0 0 0-.781.056L6.152 5.922a.173.173 0 0 1-.261 0L.973.192a.553.553 0 1 0-.84.721l5.623 6.55c.137.16.385.16.524.001L11.865.918c.2-.23.175-.58-.056-.78Z", fill: "#999", fillRule: "nonzero" }));
export { SvgArrowDown as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuODEuMTM4YS41NTMuNTUzIDAgMCAwLS43ODEuMDU2TDYuMTUyIDUuOTIyYS4xNzMuMTczIDAgMCAxLS4yNjEgMEwuOTczLjE5MmEuNTUzLjU1MyAwIDEgMC0uODQuNzIxbDUuNjIzIDYuNTVjLjEzNy4xNi4zODUuMTYuNTI0LjAwMUwxMS44NjUuOTE4Yy4yLS4yMy4xNzUtLjU4LS4wNTYtLjc4WiIgZmlsbD0iIzk5OSIgZmlsbC1ydWxlPSJub256ZXJvIi8+PC9zdmc+";
